import { render, staticRenderFns } from "./LockWidget.vue?vue&type=template&id=781f4567&"
import script from "./LockWidget.vue?vue&type=script&lang=ts&"
export * from "./LockWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports